/*
 * The semantic scale, in the three shapes the components need it.
 *
 * Good, needs attention, broken, neutral, informational — off the navy
 * accent's hue, so a screen full of brand colour still shows a failure at a
 * glance. `TONES` is composed from the two halves below, so a glyph and the
 * pill beside it cannot be two colours; `Badge`, `Callout`, `IconBadge`,
 * `CodeBlock` and the disclosure panels all paint from these.
 */

export const TONE_INK = {
  default: 'text-foreground-2',
  success: 'text-ok',
  warning: 'text-warn',
  error: 'text-destructive',
  info: 'text-info',
} as const

export type Tone = keyof typeof TONE_INK

/** The ground alone, for a block that carries its own ink. */
export const TONE_GROUNDS = {
  default: 'bg-line-soft',
  success: 'bg-ok-soft',
  warning: 'bg-warn-soft',
  error: 'bg-destructive-soft',
  info: 'bg-info-soft',
} as const satisfies Record<Tone, string>

// `cva` takes a flat string per variant, so the pair is joined here.
export const TONES = {
  default: `${TONE_GROUNDS.default} ${TONE_INK.default}`,
  success: `${TONE_GROUNDS.success} ${TONE_INK.success}`,
  warning: `${TONE_GROUNDS.warning} ${TONE_INK.warning}`,
  error: `${TONE_GROUNDS.error} ${TONE_INK.error}`,
  info: `${TONE_GROUNDS.info} ${TONE_INK.info}`,
} as const satisfies Record<Tone, string>

/** The rule around a block of the same tone. */
export const TONE_BORDERS = {
  default: 'border-border',
  success: 'border-ok-soft',
  warning: 'border-warn-soft',
  error: 'border-destructive-soft',
  info: 'border-info-soft',
} as const satisfies Record<Tone, string>
